import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=f0428a88&scoped=true&"
import script from "./bindWechat.vue?vue&type=script&lang=js&"
export * from "./bindWechat.vue?vue&type=script&lang=js&"
import style0 from "./bindWechat.vue?vue&type=style&index=0&id=f0428a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0428a88",
  null
  
)

export default component.exports